import { IWork } from "../../types/work.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getWorks({
  status = [],
  search = "",
  page = 1,
  itemsPerPage = 10,
  orderBy = "name",
  fields = "name,code,category,brand,minQuantity,preventive,corrective,misuse, sellPrice",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/works?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<IWork[]>;

  const data = result.data.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  return { ok: result.ok, data, totalItems: result.data.length };
}

export async function getWorkById(id: string) {
  const url = `${API_URL}/work/${id}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<IWork>;

  return { ok: result.ok, data: result.data };
}

export async function createWork(data: IWork) {
  const url = `${API_URL}/work`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return makeRequestDebounced(url, options) as Promise<ApiResponseType<IWork>>;
}

export async function updateWork(data: IWork) {
  const url = `${API_URL}/work`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return makeRequestDebounced(url, options) as Promise<ApiResponseType<IWork>>;
}
